import { render, staticRenderFns } from "./ankController.vue?vue&type=template&id=cc665d56&"
import script from "./ankController.vue?vue&type=script&lang=js&"
export * from "./ankController.vue?vue&type=script&lang=js&"
import style0 from "./ankController.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports